import { render, staticRenderFns } from "./xiaofuDetail.vue?vue&type=template&id=0d12b050&scoped=true&"
import script from "./xiaofuDetail.vue?vue&type=script&lang=js&"
export * from "./xiaofuDetail.vue?vue&type=script&lang=js&"
import style0 from "./xiaofuDetail.vue?vue&type=style&index=0&id=0d12b050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12b050",
  null
  
)

export default component.exports